import { createGlobalStyle } from 'styled-components'
import get from 'lodash/get'

export const SCREEN_SIZES = {
  largeDesktop: 1600,
  mediumDesktop: 1400,
  desktop: 1200,
  smallDesktop: 1024,
  tabletLandscape: 900,
  tabletPortrait: 600,
  mobileLarge: 425,
  mobileMedium: 375,
}

export const sizes = {
  mobileMedium: `(min-width: ${SCREEN_SIZES.mobileMedium}px)`,
  mobileLarge: `(min-width: ${SCREEN_SIZES.mobileLarge}px)`,
  tabletPortrait: `(min-width: ${SCREEN_SIZES.tabletPortrait}px)`,
  tabletLandscape: `(min-width: ${SCREEN_SIZES.tabletLandscape}px)`,
  smallDesktop: `(min-width: ${SCREEN_SIZES.smallDesktop}px)`,
  desktop: `(min-width: ${SCREEN_SIZES.desktop}px)`,
  mediumDesktop: `(min-width: ${SCREEN_SIZES.mediumDesktop}px)`,
  largeDesktop: `(min-width: ${SCREEN_SIZES.largeDesktop}px)`,
}

export const th = (path) => (props) => get(props.theme, path)

// All the code that controls vertical stacking is in one place. The idea being
// that you could slip something in between later if need be, which you couldn't
// if you did 1, 2, 3, etc, because z-index doesn't support decimals.
export const zIndexes = {
  notification: 9000,
  overlay: 8000,
  modal: 7000,
  navigation: 6000,
  dropdown: 5000,
}

export const theme = {
  colors: {
    text: '#273C49',
    white: '#FFF',
    black: '#273C49',

    orchid: '#DA72C5',
    keyLimePie: '#D1C627',
    pictonBlue: '#50AEEB',
    sushi: '#71C13A',
    indigo: '#5656C2',
    brandyPunch: '#E5A34C',

    turquoise: '#5CC6C7',
    fadedTurquoise: '#5CC6C799',
    halfBaked: '#77C4C6',
  },
  fonts: {
    headings: 'Nimbus, serif',
    body: 'Inter, sans-serif',
  },
  shadow: '0px 3px 6px #00000029',
}

export const GlobalStyle = createGlobalStyle`
  html, body {
    width: 100%;
    height: 100%;
  }

  input,
  textarea,
  select {
    outline: none;
    border: 0;
  }

  body {
    margin: 0;
    padding: 0;
    font: 100%/1.33 ${th('fonts.body')};
    color: ${th('colors.primaryText')};
    background-color: ${th('colors.black')};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    letter-spacing: -0.01em;
  }

  * {
    box-sizing: border-box;
  }

  h1 {
    font-size: 30px;
    margin: 0;
    line-height: 1;
    letter-spacing: -1.34px;

    @media ${sizes.tabletPortrait} {
      font-size: 40px;
    }
  }

  a {
    transition: color 0.2s;
    
    :hover {
      color: ${th('colors.turquoise')};
    }
  }
`
